import keyBy from 'lodash/keyBy';
import mapValues from 'lodash/mapValues';

export function getPlaceInfos(geoCode: google.maps.GeocoderResult, place: Record<string, any>) {
  const { address_components: components = [] } = geoCode;
  const componentMap = mapValues(
    keyBy(components, (c) => c.types[0]),
    (c) => c.long_name,
  );

  return {
    ...place,
    formatted_address: geoCode.formatted_address,
    latitude: geoCode.geometry?.location?.lat() ?? null,
    longitude: geoCode.geometry?.location?.lng() ?? null,
    postal_code: componentMap['postal_code'] || null,
    city: componentMap['locality'] || componentMap['postal_town'] || null,
    region: componentMap['administrative_area_level_1'] || null,
    department: componentMap['administrative_area_level_2'] || null,
    country: componentMap['country'] || null,
  };
}
